import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO RECUPERAR A MI HIJO — ACCESO INMEDIATO POR SOLO $6.39 USD',
  className = '',
  href
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(212, 168, 83, 0)', '0px 0px 20px rgba(212, 168, 83, 0.6)', '0px 0px 0px rgba(212, 168, 83, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity
    }
  }} className={`w-full bg-brand-gold hover:bg-brand-gold-hover text-brand-navy font-bold py-4 px-6 rounded-xl shadow-lg text-base md:text-lg transition-colors flex flex-col items-center justify-center text-center ${className}`} onClick={() => {
    if (href) {
      window.open(href, '_blank');
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} data-id="element-14">
      <span data-id="element-15">{text}</span>
    </motion.button>;
}